import { TabContext, TabList, TabPanel } from "@mui/lab";
import Tab from "@mui/material/Tab";
import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";

function SimpleTab({
  header1,
  header2,
  icon1,
  icon2,
  child1,
  child2,
}) {
  const [value, setValue] = useState("tab1");
  const [width, setWidth] = useState(320);
  const parentRef = useRef();
  const theme = useTheme();

  useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      setWidth(event[0].contentBoxSize[0].inlineSize);
    });
    if (parentRef) {
      resizeObserver.observe(parentRef.current);
    }
  }, [parentRef]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box ref={parentRef} sx={{ flexGrow: 1, width: "100%" }}>
      <TabContext value={value}>
        <Box
          sx={{
            width: { width },
            borderBottom: 1,
            borderColor: "divider",
            position: "fixed",
            zIndex: 10,
            flexGrow: 1,
            backgroundColor: "background.paper",
            borderTopRightRadius: theme.shape.borderRadius,
            WebkitBorderTopLeftRadius: theme.shape.borderRadius,
          }}
        >
          <TabList variant="fullWidth" onChange={handleChange}>
            <Tab
              icon={icon1}
              iconPosition="start"
              label={header1}
              value="tab1"
            />
            <Tab
              icon={icon2}
              iconPosition="start"
              label={header2}
              value="tab2"
            />
          </TabList>
        </Box>

        <Box marginTop="48px">
          <TabPanel value="tab1">{child1}</TabPanel>
          <TabPanel value="tab2">{child2}</TabPanel>
        </Box>
      </TabContext>
    </Box>
  );
}

export default SimpleTab;
